import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { documentsApi } from '../api/index.js';

export function DocumentDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useQuery({
    queryKey: ['document', id],
    queryFn: () => documentsApi.get(id!),
    enabled: !!id,
  });

  if (isLoading) return <p>Loading…</p>;
  if (error) return <div className="alert alert-error">Failed to load document</div>;

  const d = data!.document;

  return (
    <div>
      <div style={{ marginBottom: '1rem' }}>
        <Link to="/documents" style={{ color: 'var(--color-text-muted)', fontSize: '.875rem' }}>← Documents</Link>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 700 }}>{d.fileName}</h1>
        <span className={`badge ${d.status === 'completed' ? 'badge-green' : d.status === 'failed' ? 'badge-red' : 'badge-yellow'}`}>
          {d.status}
        </span>
      </div>

      <div className="card">
        <dl style={{ display: 'grid', gridTemplateColumns: '160px 1fr', gap: '.5rem 1rem', fontSize: '.875rem' }}>
          <dt style={{ color: 'var(--color-text-muted)' }}>Source</dt>
          <dd><span className={`badge ${d.source === 'mcp' ? 'badge-green' : 'badge-gray'}`}>{d.source}</span></dd>
          <dt style={{ color: 'var(--color-text-muted)' }}>Template</dt>
          <dd><Link to={`/templates/${d.templateId}`}>{d.templateId}</Link> v{d.templateVersion}</dd>
          <dt style={{ color: 'var(--color-text-muted)' }}>Size</dt>
          <dd>{d.fileSize ? `${(d.fileSize / 1024).toFixed(1)} KB` : '–'}</dd>
          <dt style={{ color: 'var(--color-text-muted)' }}>SHA-256</dt>
          <dd style={{ fontFamily: 'monospace', fontSize: '.8rem', wordBreak: 'break-all' }}>{d.contentHash ?? '–'}</dd>
          <dt style={{ color: 'var(--color-text-muted)' }}>Created</dt>
          <dd>{new Date(d.createdAt).toLocaleString()}</dd>
          {d.completedAt && (
            <>
              <dt style={{ color: 'var(--color-text-muted)' }}>Completed</dt>
              <dd>{new Date(d.completedAt).toLocaleString()}</dd>
            </>
          )}
          {d.error && (
            <>
              <dt style={{ color: 'var(--color-text-muted)' }}>Error</dt>
              <dd style={{ color: 'var(--color-danger)' }}>{d.error}</dd>
            </>
          )}
        </dl>

        {d.status === 'completed' && (
          <a
            href={documentsApi.downloadUrl(d.id)}
            className="btn btn-primary"
            style={{ marginTop: '1.5rem', display: 'inline-block' }}
            download
          >
            Download PDF
          </a>
        )}
      </div>
    </div>
  );
}
